var map = {
	"./HTML5.svg": "03d7",
	"./alipay.svg": "8987",
	"./blog.svg": "e8ed",
	"./gitee.svg": "d7b3",
	"./github.svg": "76f4",
	"./java.svg": "cb91",
	"./linux.svg": "23b7",
	"./loading.svg": "e96b",
	"./mail.svg": "4f1b",
	"./phone.svg": "1f9a",
	"./wechat.svg": "2ecd",
	"./zhihu.svg": "8571"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfd9";